import React, { Suspense } from 'react';

import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from '@atlassian/atlassian-studio-api';
import { SentryErrorBoundary, setupSentryClient } from '@atlassian/atlassian-studio-observability';
import { PageMainContentLoadingLogo } from '@atlassian/atlassian-studio-ui-components';
import { AtlassianRelayEnvironmentProvider } from '@atlassian/relay-environment-provider';

import { AppSelector } from './AppSelector';
import { redirectToLogin } from './common/utils/redirect-utils';

setupSentryClient({
	packageName: '@atlassian/studio-foundations',
});

export const WrappedApp = (): React.JSX.Element => {
	return (
		<Suspense
			fallback={<PageMainContentLoadingLogo interactionName="studio-foundations-wrapped-app" />}
		>
			<AtlassianRelayEnvironmentProvider>
				<QueryClientProvider client={queryClient}>
					{/* @NOTE: if any errors are thrown from inside the app selector: this is Relay related,
				so we want to redirect to the login page, because this means that the user is not authenticated */}
					<SentryErrorBoundary fallbackComponent={() => null} onError={redirectToLogin}>
						<AppSelector />
					</SentryErrorBoundary>
				</QueryClientProvider>
			</AtlassianRelayEnvironmentProvider>
		</Suspense>
	);
};
